// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pk-1";
export var messageSideRight = "_pk-2";
export var orderLookupBubbleContainer = "_pk-0";
export var submitButton = "_pk-3";